import AnalyticsWebClient, { envType, originType, platformType } from "@atlassiansox/analytics-web-client";
var getAnalyticsEnvironment = function () {
    var host = window.location.host;
    if (host.includes("localhost")) {
        return envType.LOCAL;
    }
    if (host.includes("staging")) {
        return envType.STAGING;
    }
    return envType.PROD;
};
export var analyticsClient = new AnalyticsWebClient({
    env: getAnalyticsEnvironment(),
    product: "brahmos",
    version: "1.0.0",
    origin: originType.WEB,
    platform: platformType.WEB,
    locale: "en-US"
}, {
    flushBeforeUnload: true,
    useLegacyUrl: true
});
